/* eslint-disable react/jsx-key */
import React, { useEffect, useContext, useState, useRef } from "react";
import {
  sd_dashboard_edit_ico,
  sd_dashboard_side_arrow,
  sd_success_icon,
  sd_failure_icon,
} from "../../../../Assets/imageList";
import Sd_loading from "../../../../Components/sd-common-components/sd-loading";
import { SD_Context } from "../../../../context/sd-context";
import IndiaTime from "../../../../Utils/sd-moment/IndiaTime";
import "../../../../Utils/sd-styles/sd-css/main.css";
import DisplayRazorpay from "../../../../Utils/sd-razorpay/sd-razorpay-display";
import ParokshaSevaService from "../../../../services/sd-parokshaseva.service";
import { toast } from "react-toastify";
import moment from "moment";
import { withRouter } from "react-router";
import "react-toastify/dist/ReactToastify.css";
import { BASE_BANK } from "../../../../Utils/sd-axios/sd-api-url";
import PaymentPage from "../payment-pages/payement-page";

toast.configure();

const Sd_dashboard_pratyakshaseva_booking_confirm = ({ history }) => {
  //-------------------------------------------------------------states-----------------------------------------------------------//

  const {
    setActive,
    setActivePath,
    currentBookingPratyaksha,
    setcurrentBookingPratyaksha,
    userData,
    paymentPageFlag,
    setPaymentPageFlag,
    logout,
  } = useContext(SD_Context);
  const [successOrfailureFlag, setSuccessOrfailureFlag] = useState(false);
  const [status, setStatus] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedlanguage, setSelectedlanguage] = useState("en-in");
  const supportedLanguages = ["en-in", "jp-in", "de-in", "es-in"];
  const templeID = process.env.REACT_APP_TEMPLE ?? "SDMSD";
  const [loading, setLoading] = useState(true);
  const [dissmissed, setDissmissed] = useState("");
  const [halfState, setHalfState] = useState(null);
  const refContainer = useRef();
  // const [charges, setCharges] = useState("");
  const [timestamp, setTimestamp] = useState("");

  //-------------------------------------------------------------states-----------------------------------------------------------//

  //-------------------------------------------------------------useeffect-----------------------------------------------------------//

  useEffect(() => {
    if (dissmissed === "failed") {
      setErrorMsg("Cancelled by User");
      setSuccessOrfailureFlag(true);
      setStatus("failed");
      setLoading(false);
      setDissmissed("");
    }
  }, [dissmissed]);

  useEffect(async () => {
    setLoading(true);
    if (
      supportedLanguages.includes(
        history?.location?.pathname?.split?.("/")?.[1]
      )
    ) {
      setSelectedlanguage(history?.location?.pathname?.split?.("/")?.[1]);
    } else {
      setSelectedlanguage("en-in");
    }
    setActive("onlinebooking-pratyaksha-seva-confirm-details");
    setActivePath(
      "Onlinebooking-Pratyaksha Seva-Enter Details-Confirm Details"
    );
    setTimestamp("");

    const localData = JSON.parse(localStorage.getItem("payment-context"));
    if (!currentBookingPratyaksha) {
      if (localData) {
        if (localData.responseData) {
          setHalfState(localData.responseData);
          setcurrentBookingPratyaksha(localData.bookingData);
          setTimeout(() => {
            setPaymentPageFlag(true);
          }, 1000);
        } else {
          setcurrentBookingPratyaksha(localData.bookingData);
        }
      } else {
        history?.push(
          `/${selectedlanguage}/devotee-app/online-booking/pratyaksha-seva`
        );
      }
    }

    setLoading(false);
    return () => {
      setTimestamp("");
    };
  }, []);

  useEffect(() => {
    refContainer?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [status]);

  //-------------------------------------------------------------useeffect-----------------------------------------------------------//

  //-------------------------------------------------------------functions-----------------------------------------------------------//
  const getData = () => {
    let array = [];

    currentBookingPratyaksha.selectedArray.map((item) => {
      array.push(
        <>
          <td className="sd-bl-none">
            {item?.name}
            {currentBookingPratyaksha?.slot?.productSlot && <br></br>}
            {currentBookingPratyaksha?.slot?.productSlot &&
              `Slot Time :   ${moment(
                currentBookingPratyaksha?.slot?.productSlot?.startTime,
                "HH:mm:ss"
              ).format("hh:mm A")}
            `}
            <br></br> (Pratyaksha Seva)
          </td>
          <td>Persons - {currentBookingPratyaksha?.noPersons}</td>
        </>
      );
    });
    return array;
  };

  const getDetailsFunction = () => {
    let array = [];
    let i = 0;
    currentBookingPratyaksha?.personStates.map((obj) => {
      if (obj?.name !== "") {
        array.push(
          <tr>
            <td>{i + 1}</td>
            <td>{obj?.name}</td>
            <td>{currentBookingPratyaksha?.gothram}</td>
            <td>
              {obj?.idProofNumber}({obj?.idProofType})
            </td>
          </tr>
        );
      }
      i++;
    });
    return array;
  };

  const handleSubmit = async () => {
    let res;
    if (!halfState) {
      try {
        setLoading(true);
        let dup = [...currentBookingPratyaksha?.personStates];
        let arrayEx = dup.map((e) => {
          return {
            personName: e?.name,
            documentType: e.idProofType,
            documentId: e.idProofNumber,
          };
        });

        let schema = {
          cartContains: ["seva"],
          sevaBookings: [
            {
              sevaSlotId: currentBookingPratyaksha?.slot?.productSlot?.id,
              bookingDate: moment(currentBookingPratyaksha?.startDate).format(
                "YYYY-MM-DD"
              ),
              phoneNumber: `+${currentBookingPratyaksha?.mobile}`,
              personDetails: arrayEx,
              gothram: currentBookingPratyaksha?.gothram,
            },
          ],
          returnPriceStats: false,
        };
        if (currentBookingPratyaksha?.addonsList?.length > 0) {
          currentBookingPratyaksha?.addonsList?.map((item) => {
            if (!schema?.cartContains?.includes(item?.slot?.type)) {
              schema?.cartContains?.push(item?.slot?.type);
              if (item?.slot?.type === "darshanam") {
                schema.darshanamBookings = [];
              }
            }
            item?.devoteeList?.map((e) => {
              if (item?.slot?.type === "darshanam") {
                schema.darshanamBookings = [
                  ...schema?.darshanamBookings,
                  {
                    darshanamSlotId: item?.slot?.productSlot?.id,
                    bookingDate: moment(
                      currentBookingPratyaksha?.startDate
                    ).format("YYYY-MM-DD"),
                    phoneNumber: `+${currentBookingPratyaksha?.mobile}`,
                    personDetails: [
                      {
                        personName: e?.name,
                        documentType: "aadhar",
                        documentId: e.idProofNumber,
                      },
                    ],
                  },
                ];
              }
              if (item?.slot?.type === "seva") {
                schema.sevaBookings = [
                  ...schema?.sevaBookings,
                  {
                    sevaSlotId: item?.slot?.productSlot?.id,
                    bookingDate: moment(
                      currentBookingPratyaksha?.startDate
                    ).format("YYYY-MM-DD"),
                    phoneNumber: `+${currentBookingPratyaksha?.mobile}`,
                    personDetails: [
                      {
                        personName: e?.name,
                        documentType: "aadhar",
                        documentId: e.idProofNumber,
                      },
                    ],
                  },
                ];
              }
            });
          });
        }
        if (
          currentBookingPratyaksha?.res.templePaymentConfig.configuration
            .type === "ccavenue"
        ) {
          schema.returnURL = `${window.location.origin}/en-in/devotee-app/online-booking/payment-status`;
        }
        res = await ParokshaSevaService.bookings(schema, templeID);
        setHalfState(res);
        localStorage.setItem(
          "payment-context",
          JSON.stringify({
            responseData: {
              data: {
                productDetails: res.cartItems.seva[0].productDetails,
                price: res.priceStats.serviceAmount,
                personDetails: res.cartItems.seva[0].sevaBooking.personDetails,
              },
              ...res,
            },
            bookingData: currentBookingPratyaksha,
            from: "pratyakshaSeva",
          })
        );
      } catch (e) {
        // console.log(e);
        toast.error(e.message);
        if (e.message === "Session Expired") {
          logout();

          history?.push(
            `/${selectedlanguage}/devotee/signin?to=devotee-app/online-booking/pratyaksha-seva`
          );
        }
        setLoading(false);

        return;
      }
    }
    if (res?.priceStats.totalAmount === 0) {
      setHalfState(null);
      setSuccessOrfailureFlag(true);
      setStatus("success");
      setTimestamp("");
      setLoading(false);
      return;
    }
    try {
      if (halfState !== null) {
        if (Math.floor((Date.now() - timestamp) / 1000) > 900) {
          toast.error(
            "Redirecting to Previous Page as buffer time of 15 min for retrying the payment has been exceeded."
          );
          setTimestamp("");
          setTimeout(() => {
            history?.push(
              `/${selectedlanguage}/devotee-app/online-booking/pratyaksha-seva/booking/ganapathi-homam`
            );
          }, 3000);
          return;
        }
        if (
          currentBookingPratyaksha?.res.templePaymentConfig.configuration
            .type === "ccavenue"
        ) {
          if (halfState || JSON.parse(localStorage.getItem("payment"))) {
            setLoading(false);
            setTimestamp("");
            setPaymentPageFlag(true);
            return;
          }
        } else if (
          currentBookingPratyaksha?.res.templePaymentConfig.configuration
            .type === "razorpay"
        ) {
          await DisplayRazorpay(
            halfState?.paymentInformation?.razorOrder?.id,
            halfState?.paymentInformation?.razorOrder?.currency,
            halfState?.paymentInformation?.razorOrder?.amount,
            halfState?.cartItems?.donation,
            halfState?.paymentInformation?.onlinePaymentEntity?.id,
            BASE_BANK,
            setDissmissed,
            userData,
            dissmissed,
            halfState?.priceStats?.templePaymentConfig?.razorpay?.key,
            templeID
          );
          setHalfState(null);
          // setcurrentBookingPratyaksha(null);
          setTimestamp("");
          setSuccessOrfailureFlag(true);
          setStatus("success");
          setLoading(false);
        } else {
          setHalfState(null);
          setTimestamp("");
          setLoading(false);
          toast.error(
            "Payment gateway issue. Please contact temple authorities"
          );
        }
      } else {
        setTimestamp(Date.now());

        if (
          currentBookingPratyaksha?.res.templePaymentConfig.configuration
            .type === "ccavenue"
        ) {
          if (res || JSON.parse(localStorage.getItem("payment"))) {
            setLoading(false);
            setTimestamp("");
            setPaymentPageFlag(true);
            return;
          }
        } else if (
          currentBookingPratyaksha?.res.templePaymentConfig.configuration
            .type === "razorpay"
        ) {
          await DisplayRazorpay(
            res?.paymentInformation?.razorOrder?.id,
            res?.paymentInformation?.razorOrder?.currency,
            res?.paymentInformation?.razorOrder?.amount,
            res?.cartItems?.donation,
            res?.paymentInformation?.onlinePaymentEntity?.id,
            BASE_BANK,
            setDissmissed,
            userData,
            dissmissed,
            res?.priceStats?.templePaymentConfig?.razorpay?.key,
            templeID
          );
          setHalfState(null);
          setSuccessOrfailureFlag(true);
          setStatus("success");
          setTimestamp("");
          // setcurrentBookingPratyaksha(null);
          setLoading(false);
        } else {
          toast.error({
            message:
              "Something went wrong. Please try again or contact us through support.",
          });
          setLoading(false);
        }
      }
    } catch (e) {
      // console.log(e);
      setErrorMsg(e.message);
      setSuccessOrfailureFlag(true);
      setStatus("failed");
      setLoading(false);
    }
  };

  const getStatusFunction = () => {
    switch (status) {
      case "success":
        return (
          <div className="sd-success" ref={refContainer}>
            <div className="sd-success-top sd-green">
              <img src={sd_success_icon} alt="success" /> <p>Success</p>
            </div>

            <div className="sd-success-bottom">
              <h3>
                Confirmed! Your online booking for
                {currentBookingPratyaksha.selectedArray.map((item) => {
                  return (
                    <>
                      {` ${item?.name} `}
                      on
                      {` ${moment(currentBookingPratyaksha.startDate).format(
                        "DD-MM-YYYY"
                      )} `}
                      <>
                        <p>
                          {item.startDate &&
                            IndiaTime(item.startDate, "HH:mm:ss").format(
                              "hh:mm A"
                            )}
                        </p>
                      </>
                    </>
                  );
                })}
                has been made successfully. Looking forward to meeting you on a
                journey towards spirituality.
              </h3>
              <div className="sd-success-bottom-down">
                <p
                  className="sd-border-right"
                  onClick={() => {
                    setcurrentBookingPratyaksha(null);

                    history?.push(
                      `/${selectedlanguage}/devotee-app/booking-history`
                    );
                  }}
                >
                  Booking History
                </p>
                <p
                  onClick={() => {
                    setcurrentBookingPratyaksha(null);
                    history?.push(`/${selectedlanguage}/home`);
                  }}
                >
                  Go to Home
                </p>
              </div>
            </div>
          </div>
        );
      case "failed":
        return (
          <div className="sd-success" ref={refContainer}>
            <div className="sd-success-top sd-redback">
              <img src={sd_failure_icon} alt="success" />
              <p>Sorry, your booking failed! {errorMsg} </p>
            </div>
            <div className="sd-success-bottom">
              <h3>
                Booking failed! Your online booking for
                {currentBookingPratyaksha.selectedArray.map((item) => {
                  return (
                    <>
                      {item?.name} at
                      {IndiaTime(item?.startDate).format("hh:mm A") ===
                      IndiaTime(item?.endDate).format("hh:mm A") ? (
                        <p>
                          {item.startDate &&
                            IndiaTime(item.startDate).format("hh:mm A")}
                        </p>
                      ) : (
                        <p>
                          {item.startDate &&
                            IndiaTime(item.startDate).format("hh:mm A")}
                          -
                          {item.end_date &&
                            IndiaTime(item.end_date).format("hh:mm A")}
                        </p>
                      )}
                      on
                      <p>
                        {moment(currentBookingPratyaksha.startDate).format(
                          "DD-MM-YYYY"
                        )}
                      </p>
                    </>
                  );
                })}
                failed. An error has occurred. Check your booking history or SMS
                after 20 mins for confirmation. Please note that any funds
                debited will credit back to your account within 7 working days.
              </h3>
              <div className="sd-success-bottom-down">
                <p
                  className="sd-border-right"
                  onClick={() => {
                    setStatus("");
                    setSuccessOrfailureFlag(false);
                  }}
                >
                  Try Again
                </p>
                <p
                  onClick={() => {
                    setcurrentBookingPratyaksha(null);
                    history?.push(`/${selectedlanguage}/support/contactUs`);
                  }}
                >
                  Contact Us
                </p>
              </div>
            </div>
          </div>
        );
    }
  };

  //-------------------------------------------------------------functions-----------------------------------------------------------//

  return (
    <div
      className="col-xs-12 col-sm-12 col-md-9 col-lg-9 sd-dashboard"
      style={{
        minHeight: document.getElementById("side-menu")?.offsetHeight,
      }}
    >
      {loading ? (
        <Sd_loading />
      ) : successOrfailureFlag ? (
        getStatusFunction()
      ) : (
        <div className="sd-confirm-details">
          <h2 className="sd-side-heading fw400">
            <span className="fw400">
              <span className="fw700">Confirm</span> Details
            </span>
            <a
              onClick={() => {
                history?.push(
                  `/${selectedlanguage}/devotee-app/online-booking/pratyaksha-seva/booking/${currentBookingPratyaksha.selectedArray[0]?.name
                    ?.replace?.(/\s/g, "-")
                    .toLowerCase()}`
                );
              }}
              className="sd-confirm-edit-button"
            >
              <img src={sd_dashboard_edit_ico} /> Edit details
            </a>
          </h2>
          <div className="clearfix  sd-booking-details">
            <h4>Booking Details</h4>
            <table className="table table-bordered sd-toggle-table">
              <thead>
                <tr>
                  <th width="35%">Booking for</th>
                  <th width="20%">No of Persons</th>
                  <th width="20%">Date</th>
                  <th width="25%">Total Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* <td style={{ display: "flex", flexDirection: "column" }}> */}
                  {getData()}
                  {/* </td> */}
                  <td>
                    {moment(currentBookingPratyaksha.startDate).format(
                      "DD-MM-YYYY"
                    )}
                  </td>
                  <td>
                    Rs. {currentBookingPratyaksha?.res?.totalAmount ?? 0}.00{" "}
                    <br /> (Handling charges: Rs.
                    {parseFloat(
                      currentBookingPratyaksha?.res?.templeFee
                    ).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  {currentBookingPratyaksha?.addonsList?.length > 0 && (
                    <>
                      {currentBookingPratyaksha?.addonsList?.map((item) => {
                        return (
                          <>
                            <td className="sd-bl-none">
                              <hr />
                              {item?.slot?.productSlot?.product?.name} - Rs.{" "}
                              {item?.slot?.productSlot?.product?.price *
                                item?.noofPersons}
                              <br />
                              Slot
                              {moment(
                                item?.slot?.productSlot?.startTime,
                                "HH:mm:ss"
                              ).format("hh:mm A")}{" "}
                            </td>
                            <td>
                              <hr />
                              Persons - {item?.devoteeList?.length}
                            </td>
                          </>
                        );
                      })}
                    </>
                  )}
                </tr>
              </tbody>
            </table>

            <div className="sd-table-detoggler">
              <div className="sd-booking-details-up bg">
                <div className="sd-actions-icons-main">
                  <label style={{ color: "grey", fontWeight: 500 }}>
                    BOOKING FOR
                  </label>
                  <br />
                  <span style={{ fontWeight: "600" }}>{getData()}</span>
                </div>
              </div>
              <div className="sd-booking-details-down ">
                <div>
                  <label>DATE/SLOT</label>
                  <span>
                    {moment(currentBookingPratyaksha.startDate).format(
                      "DD-MM-YYYY"
                    )}
                  </span>
                </div>
                {/* {currentBooking.occasion && (
                  <div>
                    
                    <label>OCCASION</label>
                    <span> {currentBooking?.occasion}</span>
                  </div>
                )} */}
                <div style={{ marginRight: "0px" }}>
                  <label>AMOUNT</label>
                  <span>
                    {userData?.phone.substring(0, 3) === "+91" ? "Rs." : "$"}
                    {currentBookingPratyaksha?.res?.totalAmount}.00
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      (Handling charges:
                      {userData?.phone.substring(0, 3) === "+91" ? "Rs." : "$"}
                      {~~currentBookingPratyaksha?.res?.additionalAmount}.00)
                    </span>
                  </span>
                </div>
              </div>
              {currentBookingPratyaksha.occasion && (
                <div className="sd-booking-details-down ">
                  <div>
                    <label>OCCASION</label>
                    <span> {currentBookingPratyaksha?.occasion}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="clearfix sd-devotee-details mt-30">
            <h4>Devotee Details</h4>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th width="5%">S.No.</th>
                  <th width="25%">Name</th>
                  <th width="25%">Gothram</th>
                  <th width="40%">ID Proof</th>
                </tr>
              </thead>
              <tbody>{getDetailsFunction()}</tbody>
            </table>
          </div>
          <div className="clearfix mt-50 sd-form">
            <a
              className="sd-btn-orange"
              onClick={() => {
                if (!loading) {
                  handleSubmit();
                }
              }}
            >
              Proceed to Payment
              <img
                className="sd-arrow-btn ml-5"
                src={sd_dashboard_side_arrow}
              />
            </a>
          </div>
        </div>
      )}
      {paymentPageFlag && (
        <PaymentPage
          bookingData={{
            responseData: {
              data: {
                productDetails: halfState?.cartItems?.seva[0].productDetails,
                price: halfState?.cartItems.seva[0].sevaBooking.price,
                personDetails:
                  halfState?.cartItems?.seva[0].sevaBooking.personDetails,
              },
              ...halfState,
            },
            bookingData: currentBookingPratyaksha,
            from: "pratyakshaSeva",
          }}
        />
      )}
    </div>
  );
};
export default withRouter(Sd_dashboard_pratyakshaseva_booking_confirm);
